<template>
  <div class="brokeragelist">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"
        ></i>
        用户列表
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px" @click="geting()">刷新</div>
        </div>
      </div>
    </div>

    <div v-if="role" style="width: 1056px;margin: 0 auto">
      <div class="form-title">
        <div style="float: left;line-height: 46px;padding-left: 10px;">筛选查询</div>
      </div>
      <div class="search-box">
        <el-row class="search" :gutter="10">
          <el-col :span="2">
            <div class="label">用户账号:</div>
          </el-col>
          <el-col :span="4">
            <el-input clearable v-model="s_mobile" size="small" placeholder="用户账号"></el-input>
          </el-col>

          <el-col :span="4">
            <div class="label">分享时间:</div>
          </el-col>
          <el-col :span="4">
            <template>
              <div class="block">
                <el-date-picker
                  value-format="timestamp"
                  v-model="time"
                  clearable
                  size="small"
                  placeholder="请选择时间"
                ></el-date-picker>
              </div>
            </template>
          </el-col>
          <el-col :span="8" align="center">
            <div class="filtrate_seek_sousuo" @click="geting()">搜索</div>
          </el-col>
        </el-row>
      </div>
      <div class="filtrate_center">
        <div class="center_list_head">
          <div class="center_list_head_left">
            <div>
              <i class="fas fa-bars"></i>
            </div>
            <div>数据列表</div>
          </div>
        </div>
        <div class="center_list_center"></div>
      </div>
      <el-table
        :data="tableData"
        @row-click="indexMethod"
        border
        style="width: 100%"
        ref="multipleTable"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column width="200" label="订单编号" align="center">
          <template slot-scope="scope">
            <router-link target="_blank" :to="'/admin/d_viewOrde/' + scope.row.order_id + '/1'">
              <el-link>{{scope.row.orderCode}}</el-link>
            </router-link>
          </template>
        </el-table-column>

        <el-table-column prop="open_id" width="200" label="微信标识" align="center"></el-table-column>
        <el-table-column prop="back_money" label="佣金" align="center"></el-table-column>
        <el-table-column prop="back_time" label="返还时间" align="center"></el-table-column>
        <el-table-column prop="create_date" label="创建时间" align="center"></el-table-column>
        <el-table-column label="购买者" align="center">
          <template slot-scope="scope">
            <router-link target="_blank" :to="'/admin/y_userLook/' + scope.row.c_mobile + '/1'">
              <el-link>{{scope.row.c_mobile}}</el-link>
            </router-link>
          </template>
        </el-table-column>
        <el-table-column width="150" label="分享者" align="center">
          <template slot-scope="scope">
            <router-link target="_blank" :to="'/admin/y_userLook/' + scope.row.s_mobile + '/1'">
              <el-link>{{scope.row.s_mobile}}</el-link>
            </router-link>
          </template>
        </el-table-column>
        <el-table-column width="120" label="操作" align="center" name="bianji">
          <template style="display:flex;padding:0;margin:0" slot-scope="scope">
            <button class="button1" @click="details">查看</button>
            <button
              v-if="scope.row.back_time == '未返现'"
              class="button1"
              @click="change_cive(scope.row.orderCode,scope.row.back_money)"
            >发红包</button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pager1" style="display:flex;justify-content: space-between">
        <div>
          <el-button size="small" @click="all_cive">拼红包</el-button>
        </div>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="15"
          @current-change="setPage"
          hide-on-single-page
        ></el-pagination>
      </div>
    </div>
    <noAccess v-else></noAccess>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="50%">
      <div style="line-height:30px">
        <div>
          <span>姓名 :</span>
          <span>{{addres[1]}}</span>
        </div>
        <div>
          <span>电话 :</span>
          <span>{{addres[0]}}</span>
        </div>
        <div>
          <span>地址 :</span>
          <span>{{addres[2]}}{{addres[3]}}{{addres[4]}}{{addres[5]}}</span>
        </div>
        <div>
          <span>价格 :</span>
          <span>{{pay_money}}</span>
        </div>
        <div class="clearfix">
          <el-card
            v-for="i in proud_list"
            :key="i.p_id"
            :body-style="{ padding: '0px' }"
            style="float:left;margin:10px 0 20px 25px;width:200px"
          >
            <img style="width:200px;height:200px" :src="serve + i.images" class="image" />
            <div style="padding: 14px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis">
              <span>{{i.title}}</span>
              <div style="color:red">{{i.price}}</div>
            </div>
          </el-card>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "list",
  data() {
    return {
      serve: this.$store.state.serve,
      role:true,
      token: this.$cookies.get("token"),
      username: this.$cookies.get("username"),
      page: null,
      total: 0,
      tableData: [],
      s_mobile: "",
      time: "",
      dialogVisible: false,

      addres: [],
      pay_money: "",
      proud_list: [],
      arr_order: []
    };
  },
  created() {
    this.$store.state.topActiveId = 4;
    this.$store.state.leftTitle = "佣金列表";
    this.geting();
  },
  watch: {
    //监听全选状态
  },
  methods: {
    all_cive() {
      this.axios
        .get(this.serve + "/admin/adminSendPack", {
          params: {
            username: this.username,
            token: this.token,
            orderCodeArr: JSON.stringify(this.arr_order)
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.$message({
              type: "success",
              message: res.data.msg
            });
            this.geting();
          } else if (res.data.status == "error") {
            this.err_msage(res.data.msg);
          }
        });
    },
    handleSelectionChange(val) {
      var arr = [];
      for (var i in val) {
        if (val[i].open_id !== val[0].open_id) {
          this.err_msage("请选择相同的微信标识");
          break;
        } else if (val[i].back_time !== "未返现") {
          this.err_msage("请选择未返现的订单，否则选择无效");
          break;
        }
        arr.push(val[i].orderCode);
      }
      this.arr_order = arr;
    },
    err_msage(msg) {
      this.$message.error(msg);
    },
    details() {
      this.dialogVisible = true;
    },
    change_cive(orderCode, money) {
      if (money < 1) {
        return this.err_msage(
          "红包不足一元,暂不能发送红包,可以选择微信标识相同的进行拼红包"
        );
      } else if (money >= 1) {
        this.axios
          .get(this.serve + "/admin/adminSendPack", {
            params: {
              username: this.username,
              token: this.token,
              orderCode
            }
          })
          .then(res => {
            if (res.data.status == "success") {
              this.$message({
                type: "success",
                message: res.data.msg
              });
              this.geting();
            } else if (res.data.status == "error") {
              this.err_msage(res.data.msg);
            }
          });
      }
    },
    indexMethod(row) {
      this.pay_money = row.pay_money;
      this.addres = row.address;
      var product = JSON.parse(row.product_list);
      this.proud_list = product;
    },
    open4() {
      //错误时返回的息状态
      this.$message.error("添加失败");
    },
    open() {
      this.$message({
        //成功时 返回的状态
        message: "添加成功",
        type: "success"
      });
    },

    setPage(v) {
      //分页
      this.page = v;
      this.geting(v);
    },

    geting(page) {
      let settime = "";
      if (this.time != "") {
        settime = this.time / 1000;
      }
      this.axios
        .get(this.serve + "/admin/share_order_list", {
          params: {
            page,
            username: this.username,
            token: this.token,
            mobile: this.s_mobile,
            time: settime
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.tableData = res.data.data;
          }else{
            if(res.data.msg == "无权访问"){
              this.role = false
            }
          }
        });
    }
  }
};
</script>
<style lang="scss">
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}
.brokeragelist {
  background: #f5f5f5;
  color: #333;
  padding-bottom: 100px;
  min-height: 1000px;
  .topBar {
    margin-bottom: 40px;
  }
  .search-box {
    width: 1054px;
    height: 86px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
  }
  .filtrate_seek_sousuo {
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
    width: 74px;
    height: 28px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    position: absolute;
    right: 18px;
    top: 29px;
    cursor: pointer;
  }
  .el-pagination {
    text-align: left;
  }
  .filtrate_seek_sousuo:hover {
    background-color: #0099ff;
    color: #fff;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
    .rutun {
      width: 78px;
      height: 28px;
      background: #fff;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      margin-top: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .rutun:hover {
      color: #0099ff;
    }
  }
  .filtrate_center {
    margin-top: 19px;
    border-left: 1px solid rgba(221, 221, 221, 1);
    border-top: 1px solid rgba(221, 221, 221, 1);
    border-right: 1px solid rgba(221, 221, 221, 1);
  }
  .button1 {
    // border: 0;
    border: none;
    outline: none;
    background: none;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
    cursor: pointer;
  }
  .button1:hover {
    color: #0099ff;
  }
  .el-row {
    display: flex;
    justify-content: center;
  }
  .cell {
    color: #606266 !important;
  }
  .center_list_head {
    width: 100%;
    height: 46px;
    // background: orange;
    display: flex;
    justify-content: space-between;
    .center_list_head_left {
      display: flex;
      align-items: center;
      > div {
        margin-left: 10px;
      }
    }
    .center_list_head_rig {
      width: 100px;
      height: 30px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 12px;
      font-family: "MicrosoftYaHeiLight";
      font-weight: 300;
      color: rgba(153, 153, 153, 1);
      margin: 7px 30px 0 0;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
    }
    .center_list_head_rig:hover {
      color: #0099ff;
    }
  }

  .menu {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .btn3 {
      i {
        font-style: normal;
        color: #f64e62;
      }
    }
    .btn3:hover i {
      color: #fff;
    }
  }
  .search .el-col {
    line-height: 80px;
  }
  .label {
    text-align: right;
    padding-right: 10px;
    font-size: 14px;
  }
  .table {
    background-color: #fff;
    padding: 10px 20px;
    .el-tree-node {
      font-size: 16px;
      padding: 5px 0;
    }
  }
  .el-table_1_column_3 .cell {
    overflow: hidden;
    text-align: center;
  }
}
</style>